/**
 * Column group definitions for the employee column picker.
 *
 * - `EmployeeColumnGroup` is the exhaustive union of valid group keys.
 *   TypeScript enforces that every column's `group` field uses one of these keys.
 *
 * - `EMPLOYEE_COLUMN_GROUPS` drives the picker's display order and labels.
 *   Adding a new group here is the only change needed to make it appear in the UI.
 *   Columns are assigned to a group via their `group` field in `employeeColumns.tsx`.
 */
import { CalendarMonth, Description, Person, Public, Work } from '@mui/icons-material';
import type { ColumnGroupConfig } from '../../components/ui/tableTemplate/TableTemplateTypes';

export type { ColumnGroupConfig };

export type EmployeeColumnGroup =
  | 'identity'
  | 'location'
  | 'employmentDates'
  | 'contractInformation'
  | 'positionRemuneration';

export const EMPLOYEE_COLUMN_GROUPS: readonly ColumnGroupConfig[] = [
  { key: 'identity',             labelKey: 'columnConfigurator.groups.identity',             icon: Person },
  { key: 'location',             labelKey: 'columnConfigurator.groups.location',             icon: Public },
  { key: 'employmentDates',      labelKey: 'columnConfigurator.groups.employmentDates',      icon: CalendarMonth },
  { key: 'contractInformation',  labelKey: 'columnConfigurator.groups.contractInformation',  icon: Description },
  { key: 'positionRemuneration', labelKey: 'columnConfigurator.groups.positionRemuneration', icon: Work },
];
